import script from "./showPackages.vue?vue&type=script&setup=true&lang=js"
export * from "./showPackages.vue?vue&type=script&setup=true&lang=js"

import "./showPackages.vue?vue&type=style&index=0&id=63c70009&scoped=true&lang=css"

import exportComponent from "/Users/saameen/Documents/www/hs/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63c70009"]])

export default __exports__